/**
 * Route gate for ClinicalHUD3 Teaching mode:
 * - unsigned → auth with return path
 * - signed in, no learner profile → onboarding
 * - signed in, profile exists → children
 *
 * Does not check clinicalHudAccess, Live grant, attestation, or roles.
 * Prompt 4 mounts routes; this gate is unmounted until then.
 */
import { Navigate, useLocation } from "react-router-dom";
import Loading from "components/Loading";
import { useAuth } from "hooks/useAuth";
import { CLINICAL_HUD4_TEACHING } from "features/clinicalHud4/clinicalHud4WorkspaceConfig";
import { CLINICAL_HUD5_TEACHING } from "features/clinicalHud5/clinicalHud5WorkspaceConfig";
import { useClinicalHud3LearnerProfile } from "../useClinicalHud3LearnerProfile";
import ClinicalHud3LearnerOnboarding from "./ClinicalHud3LearnerOnboarding";

export default function RequireClinicalHud3Teaching({ children }) {
  const { user } = useAuth();
  const { loading, hasAnswered, refresh } = useClinicalHud3LearnerProfile();
  const location = useLocation();

  if (loading) return <Loading page />;

  if (!user) {
    const next = `${location.pathname}${location.search}`;
    return <Navigate to={`/auth?next=${encodeURIComponent(next)}`} replace />;
  }

  if (!hasAnswered) {
    const acuityDrill = location.pathname.startsWith("/clinical-hud-4");
    const clinicalHud5 = location.pathname.startsWith("/clinical-hud-5");
    return (
      <ClinicalHud3LearnerOnboarding
        refresh={refresh}
        productTitle={
          acuityDrill
            ? CLINICAL_HUD4_TEACHING.productTitle
            : clinicalHud5
              ? CLINICAL_HUD5_TEACHING.productTitle
              : undefined
        }
        productTagline={
          acuityDrill
            ? CLINICAL_HUD4_TEACHING.productTagline
            : clinicalHud5
              ? CLINICAL_HUD5_TEACHING.productTagline
              : undefined
        }
      />
    );
  }

  return children;
}
